import {useMutation, useQueryClient} from 'react-query';
import {useTranslation} from 'react-i18next';

import api from 'utils/api';
import {setAlert, setSuccessAlert} from 'actions/alerts';
import contentKeys from 'actions/content/queryKeys';

import playlistKeys from './queryKeys';

// eslint-disable-next-line jsdoc/require-returns, jsdoc/require-param
/**
 * @deprecated
 * Note: this hook is near to a duplicate of useUpdatePlaylistContent
 * however, the patch data they can handle are different.
 * Once the playlistSections feature is fully implemented,
 * this hook should be removed in favour of useManagePlaylistContent
 */
function useUpdatePlaylistContentDeprecated(
	playlistId,
	{successMessage, errorMessage} = {}
) {
	const {t} = useTranslation();
	const queryClient = useQueryClient();
	const queryKey = playlistKeys.singlePlaylist(playlistId);

	async function updatePlaylistContent(playlistData) {
		return api(
			'patch',
			`/api/playlists/${playlistId}/contents`,
			null,
			playlistData
		);
	}

	const {isLoading, isError, mutateAsync} = useMutation(
		updatePlaylistContent,
		{
			onSuccess: () => {
				queryClient.invalidateQueries(queryKey);
				queryClient.invalidateQueries(contentKeys.contentLogs());
				setSuccessAlert({
					title:
						successMessage ||
						t('alert_playlist_updated_successfully'),
				});
			},
			onError: () => {
				setAlert({
					title: errorMessage || t('alert_playlist_not_updated'),
				});
			},
		}
	);

	return {isLoading, isError, updatePlaylistContent: mutateAsync};
}

export default useUpdatePlaylistContentDeprecated;
